import React, { useCallback, useMemo } from "react";
import * as Scrivito from "scrivito";
import NiceModal from "@ebay/nice-modal-react";
import { DropdownItem, DropdownMenu } from "reactstrap";
import { ProductListModal } from "components/_Modals/ProductListModal";
import {
  useIsFetching,
  useSubType,
  useTopology,
  useTopologyOperation,
  useWizardActions,
} from "objs/_ConfiguratorObjs/Wizard/stores/wizardStore";
import { ProductConfiguratorModal } from "objs/_ConfiguratorObjs/Wizard/ProductConfiguratorModal/ProductConfiguratorModal";

const allowedActionsIds = [1, 8, 5, 4, 3];

export const DropDownMenuControlled = Scrivito.connect(
  ({
    id,
    orderCode = {},
    dummy,
    title,
    menu,
    groupPosition,
    hasChildren,
    selectedAccessories,
    type,
  }) => {
    const isConfiguredProduct = orderCode.seriesId;

    const { setTopologyOperation, invokeTopologyCopyAction, deleteWizardNode } =
      useWizardActions();
    const subType = useSubType();
    const topologyOperation = useTopologyOperation();
    const topology = useTopology();
    const isFetching = useIsFetching();

    const modalProps = useMemo(
      () => ({
        id,
        orderCode,
        title,
        dummy,
        type,
        wizardType: subType,
        groupPosition,
        selectedAccessories,
      }),
      [
        id,
        orderCode,
        title,
        dummy,
        type,
        subType,
        groupPosition,
        selectedAccessories,
      ],
    );

    const availableActions = useMemo(() => {
      const currentTopology = topology || [];
      const actions = currentTopology[0]?.actions || [];

      return actions.filter(
        (action) =>
          menu?.some((menuItem) => menuItem.id === action.id) &&
          allowedActionsIds.includes(action.id),
      );
    }, [menu, topology]);

    const toggleDeleteNodeModal = useCallback(() => {
      deleteWizardNode({
        sourceId: modalProps.id,
        hasChildren,
        modalTitle: title,
      });
    }, [deleteWizardNode, hasChildren, modalProps.id, title]);

    const executeAction = useCallback(
      (actionType) => {
        const variables = {
          action: actionType,
          sourceId: id,
        };

        setTopologyOperation({
          kind: actionType,
          item: id,
          variables,
        });
        invokeTopologyCopyAction({
          action: actionType,
          sourceId: id,
        });
      },
      [id, invokeTopologyCopyAction, setTopologyOperation],
    );

    const handleBackAction = useCallback(() => {
      NiceModal.show(ProductListModal, { ...modalProps, handleBackAction });
    }, [modalProps]);

    const handleClick = useCallback(
      (e, key) => {
        e.stopPropagation();
        if (isFetching) {
          return;
        }
        const actions = {
          1: () =>
            NiceModal.show(
              isConfiguredProduct ? ProductConfiguratorModal : ProductListModal,
              {
                ...modalProps,
                handleBackAction,
              },
            ),
          8: toggleDeleteNodeModal,
          5: () => executeAction("copyConfiguration"),
          4: () => executeAction("cutComponent"),
          3: () => executeAction("copyComponent"),
        };

        if (actions[key]) {
          actions[key]();
        }
      },
      [
        executeAction,
        handleBackAction,
        isConfiguredProduct,
        isFetching,
        modalProps,
        toggleDeleteNodeModal,
      ],
    );

    return (
      <DropdownMenu container="body">
        {availableActions.map((item, index) => (
          <div key={item.id}>
            <DropdownItem
              disabled={item.disabled || !!topologyOperation?.kind}
              onClick={(e) => handleClick(e, item.id)}
            >
              {item.title}
            </DropdownItem>

            {index < availableActions.length - 1 && (
              <DropdownItem divider className="mx-n1" />
            )}
          </div>
        ))}
      </DropdownMenu>
    );
  },
);
